import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "message"]

  open(event) {
    event.preventDefault()
    const el = event.currentTarget
    this._pendingUrl   = el.dataset.confirmUrl
    this._pendingParam = el.dataset.confirmParam
    this._pendingValue = el.dataset.confirmValue

    if (this.hasMessageTarget && el.dataset.confirmMessage) {
      this.messageTarget.textContent = el.dataset.confirmMessage
    }

    this.dialogTarget.showModal()
  }

  openFromSelect(event) {
    const select = event.currentTarget
    this._pendingUrl    = select.dataset.confirmUrl
    this._pendingParam  = select.dataset.confirmParam
    this._pendingValue  = select.value
    this._pendingSelect = select

    const message = select.dataset.confirmMessage
    if (this.hasMessageTarget && message) {
      this.messageTarget.textContent = message.replace("%{value}", select.value)
    }

    this.dialogTarget.showModal()
  }

  confirm() {
    this._submit(this._pendingUrl, this._pendingParam, this._pendingValue)
    this.dispatch("confirmed", { detail: { param: this._pendingParam, value: this._pendingValue } })
    this._close()
  }

  cancel() {
    if (this._pendingSelect) {
      const original = this._pendingSelect.querySelector("option[selected]")
      if (original) this._pendingSelect.value = original.value
    }
    this._close()
  }

  _submit(url, param, value) {
    const form  = document.createElement("form")
    form.method = "post"
    form.action = url

    const csrf = document.querySelector("meta[name='csrf-token']")

    form.appendChild(this._hidden("_method", "patch"))
    form.appendChild(this._hidden("authenticity_token", csrf ? csrf.content : ""))
    form.appendChild(this._hidden(param, value))

    document.body.appendChild(form)
    form.requestSubmit()
    form.remove()
  }

  _hidden(name, value) {
    const input = document.createElement("input")
    input.type  = "hidden"
    input.name  = name
    input.value = value
    return input
  }

  _close() {
    this.dialogTarget.close()
    this._pendingUrl    = null
    this._pendingParam  = null
    this._pendingValue  = null
    this._pendingSelect = null
  }
}
